module.exports = __webpack_public_path__ + "static/img/guaranteeing-seal.png";